// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { WeddingRingFragmentDoc } from './WeddingRing.fragment.generated';
import { ShopWithConfidenceProductFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../components/rings/DeliveryTimeframe.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../../../graphql/api/checkout/payment/affirmFinanceOptions.fragment.generated';
import { KlarnaFinanceOptionsFragmentDoc } from '../../../graphql/api/checkout/payment/klarnaFinanceOptions.fragment.generated';
import { ProductAnalyticsFragmentDoc } from '../composables/analytics/useProductAnalytics.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/Reviews.generated';
import { ReviewsAggregateFragmentDoc } from '../../../components/rings/ReviewsAggregate.generated';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { PageTooltipFragmentDoc } from '../../../components/layout/tooltip/PageTooltip.fragment.generated';
import { PdpAccordionItemFragmentDoc } from '../../../components/product/PdpAccordion.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const GetWeddingRingDocument = gql`
    query getWeddingRing($slug: String!, $metal: MetalCode!, $suffixSlug: String, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!, $page: String!, $pageFallback: String!) {
  catalogueWeddingRing(
    filter: {slug: $slug, primaryMetalCodes: [$metal], suffixSlug: $suffixSlug}
  ) {
    ...weddingRing
    isResizeable
    ...shopWithConfidenceProduct
    firstAvailableDeliveryDateWithoutEngraving: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: false
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDateWithEngraving: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    financeOptionsAffirm(currency: $currency, region: $region) {
      ...affirmFinanceOptions
    }
    financeOptionsKlarna(currency: $currency, region: $region) {
      ...klarnaFinanceOptions
    }
    ...productAnalytics
    reviews {
      ...reviews
    }
    reviewsAggregate {
      ...reviewsAggregate
    }
  }
  pageProductDetails(path: $page, fallback: $pageFallback, locale: $locale) {
    id
    blocks {
      ...block
    }
    meta {
      ...meta
    }
    priceExplainedTooltip {
      ...pageTooltip
    }
    accordionItems {
      ...pdpAccordionItem
    }
  }
}
    ${WeddingRingFragmentDoc}
${ShopWithConfidenceProductFragmentDoc}
${DeliveryTimeframeFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}
${KlarnaFinanceOptionsFragmentDoc}
${ProductAnalyticsFragmentDoc}
${ReviewsFragmentDoc}
${ReviewsAggregateFragmentDoc}
${BlockFragmentDoc}
${MetaFragmentDoc}
${PageTooltipFragmentDoc}
${PdpAccordionItemFragmentDoc}`;

export function useGetWeddingRingQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.GetWeddingRingQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.GetWeddingRingQuery, SchemaTypes.GetWeddingRingQueryVariables | undefined>({ query: GetWeddingRingDocument, variables: undefined, ...options });
};